export enum EventNatureTypeEnum {
    PHYSICAL = 0,
    VIRTUAL = 1,
    HYBRID = 2
}
